<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { VatDeadline } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import EditVatDeadline from '@/components/vat-deadlines/EditVatDeadline.vue';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        vatDeadline: VatDeadline;
    }

    defineProps<Props>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="vatDeadline">
        <EditVatDeadline
            v-if="hasPermission(Permission.SYSTEM_UPDATE)"
            :vat-deadline="vatDeadline"
        />
        <Delete
            v-if="hasPermission(Permission.SYSTEM_DELETE)"
            :route="route('v2.vat-deadlines.destroy', vatDeadline.vat_deadline_id)"
            :query-key="[QueryKey.VAT_DEADLINES]"
        />
    </DataTableActions>
</template>
